module.exports = __webpack_public_path__ + "static/img/Logo_SL360_transparent.63677d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_SL360_transparent.png
// module id = novS
// module chunks = 1